import { JSX, useContext } from "react";
import { cloneDeep } from "lodash";
import { CompetitiveInsightsMapOverlapTypeEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared";
import { CompetitiveInsightsMapContext } from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsMapContext";
import CheckboxDropdown from "@app/shared/checkbox-dropdown/CheckboxDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface CompetitiveInsightsMapOverlapButtonProps {
  onSetServiceAreaClick: () => void;
}

const CompetitiveInsightsMapOverlapButton = (props: CompetitiveInsightsMapOverlapButtonProps): JSX.Element => {
  const competitiveInsightsMapContext = useContext(CompetitiveInsightsMapContext);

  return (
    <div id="competitive-insights__map--overlap-button">
      <CheckboxDropdown
        buttonClassNames="qes-button-outline"
        buttonText="See County Overlaps"
        cancelText="Cancel"
        disableEmptySelection={true}
        items={competitiveInsightsMapContext.mapOverlapTypes}
        selectedItems={cloneDeep(competitiveInsightsMapContext.selectedMapOverlapTypes).filter(
          x => competitiveInsightsMapContext.mapOverlapTypes.map(y => y.key).includes(x.key)
        )}
        showSelectAll={true}
        submitText="Set Service Area"
        onSubmit={props.onSetServiceAreaClick}
        onSelectionChanged={(selectedItems: DropdownItem<CompetitiveInsightsMapOverlapTypeEnum>[]) => competitiveInsightsMapContext.setSelectedMapOverlapTypes(selectedItems)}
      />
    </div>
  );
}

export default CompetitiveInsightsMapOverlapButton;